<!--
 * @Author: Yran
 * @Date: 2021-05-19 18:05:59
 * @LastEditors: Yran
 * @LastEditTime: 2021-09-01 15:24:32
-->
<template>
  <div class="user_system">
    <a-row class="filter_row" type="flex" align="middle">
      <a-col :span="6">
        <a-form-item :wrapper-col="{ span: 24 }" style="width: 90%; margin-bottom: 0">
          <a-input v-model:value="filterData.userCode" placeholder="请输入用户花名信息" allow-clear @press-enter="selectUserClickBtn" @change="inputUserName" />
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-button type="primary" @click="selectUserClickBtn" :disabled="tableLoading">搜索</a-button>
      </a-col>
    </a-row>

    <div class="table_wrapper">
      <a-table size="small" :data-source="userDataSource" :columns="userColumns" :scroll="{ y: 200 }" row-key="userId" :pagination="paginationTable" @change="onTableChange" :loading="tableLoading">
        <template #jobs="{ record }">{{ columnMap(jobsOptions, record.jobs) }}</template>
        <template #grades="{ record }">{{ columnMap(gradeOptions, record.grades) }}</template>
        <template #roleIdList="{ record }">
          <span class="pr10" v-for="(item, index) in record.roleIdList" :key="index">{{ columnMap(rolesOptions, item) + ';' }}</span>
        </template>
        <template #operation="{ record }">
          <a-space>
            <a @click="updateUserClickBtn(record)"> 编辑 </a>
          </a-space>
        </template>
      </a-table>
    </div>

    <a-modal class="user_role_modal" v-model:visible="editUserVisible" title="编辑用户" width="27.3rem" @ok="confirmUserModalClickBtn" @cancel="cancelUserModalClickBtn" cancel-text="取消" ok-text="确认" :mask-closable="false" destroy-on-close>
      <a-form ref="userModalForm" :model="userModalData">
        <a-row>
          <a-col :span="12">
            <a-form-item :wrapper-col="{ span: 14 }" :label-col="{ span: 8 }" class="mb10" name="userCode">
              <template #label><span class="letter-spac-2em">花</span>名</template>
              {{ userModalData.userCode }}
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :wrapper-col="{ span: 14 }" :label-col="{ span: 8 }" class="mb10" label="所属部门" name="deptId">
              {{ userModalData.deptName }}
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :wrapper-col="{ span: 14 }" :label-col="{ span: 8 }" class="mb10" name="jobs">
              <template #label><span class="letter-spac-2em">岗</span>位</template>
              {{ columnMap(jobsOptions, userModalData.jobs) }}
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :wrapper-col="{ span: 14 }" :label-col="{ span: 8 }" class="mb10" name="grades">
              <template #label><span class="letter-spac-2em">职</span>级</template>
              {{ columnMap(gradeOptions, userModalData.grades) }}
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item :wrapper-col="{ span: 18 }" :label-col="{ span: 4 }" name="role">
          <template #label><span class="letter-spac-2em">角</span>色</template>
          <a-checkbox-group v-model:value="userModalData.roleIdList" style="line-height: unset; width: 100%">
            <a-row>
              <a-col v-for="(item, index) in rolesOptions" :key="index" :span="6">
                <a-checkbox :value="item.value">{{ item.text }}</a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { getDepartmentData } from '@/api/org/account.js';
import { getRoleListData } from '@/api/systemManage/roleManage.js';
import { getUserListData, updateUserData } from '@/api/systemManage/userManage.js';
import { getMenuList } from '@/api/systemManage/menuManage.js';
export default {
  data() {
    return {
      locale: zhCN,
      // 表格加载
      tableLoading: false,
      // 编辑弹窗
      editUserVisible: false,
      // 筛选数据对象
      filterData: {},
      // 角色选项
      rolesOptions: [],
      // 岗位选项
      jobsOptions: [
        { text: 'ADMIN', value: 'ADMIN' },
        { text: '运营', value: 'OPERATION' },
        { text: '编导', value: 'SCENARIST' },
        { text: '制片', value: 'FILEMAKER' },
        { text: '拍摄', value: 'PHOTOGRAPHER' },
        { text: '后期', value: 'POSTER' },
        { text: '媒介', value: 'MEDIUM' },
        { text: '销售', value: 'SELL' },
        { text: '人力', value: 'MANPOWER' },
        { text: '风控', value: 'RISKMANAGER' },
        { text: '财务', value: 'TREASURER' },
        { text: '技术', value: 'EXPLOIT' },
        { text: '其它', value: 'OTHER' },
      ],
      // 职级选项
      gradeOptions: [
        { text: '经理', value: 'MANAGER' },
        { text: '组长', value: 'GROUPLEADER' },
        { text: '组员', value: 'GROUPMEMBER' },
      ],
      // 用户列表列名
      userColumns: [
        {
          title: '用户ID',
          dataIndex: 'userId',
          key: 'userId',
          width: 80,
        },
        {
          title: '花名',
          dataIndex: 'userCode',
          key: 'userCode',
          width: 180,
        },
        {
          title: '所属部门',
          dataIndex: 'deptName',
          key: 'deptName',
        },
        {
          title: '岗位',
          dataIndex: 'jobs',
          key: 'jobs',
          slots: { customRender: 'jobs' },
          width: 120,
        },
        {
          title: '职级',
          dataIndex: 'grades',
          key: 'grades',
          slots: { customRender: 'grades' },
          width: 120,
        },
        {
          title: '角色',
          dataIndex: 'roleIdList',
          key: 'roleIdList',
          slots: { customRender: 'roleIdList' },
          ellipsis: true,
        },
        {
          title: '操作',
          dataIndex: 'operation',
          slots: {
            customRender: 'operation',
          },
        },
      ],
      // 用户列表数据源
      userDataSource: [],
      // 编辑新增用户会话框对象
      userModalData: {},
      // 部门列表数据
      departmentData: [],
      // 表格分页设置
      paginationTable: {
        limit: '30',
        page: '1',
        pageSize: 30,
        showTotal: total => `总计${total}条数据`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50'],
      },
    };
  },
  mounted() {
    this.getRoleList();
    this.getUserList();
  },
  methods: {
    /** 分页切换时
     * @param {*} pagination
     * @return {*}
     */
    onTableChange(pagination) {
      this.paginationTable.page = pagination.current.toString();
      this.paginationTable.pageSize = pagination.pageSize;
      this.paginationTable.limit = pagination.pageSize.toString();
      this.getUserList();
    },
    inputUserName() {
      this.filterData.userCode = this.filterData.userCode.trim();
      if (!this.filterData.userCode) {
        this.paginationTable.page = '1';
        this.selectUserClickBtn();
      }
    },
    /** 列字典数据映射
     * @param {Array}} columnOptions 数据源
     * @param {String} key 数据值
     * @return {*}
     */
    columnMap(columnOptions, key) {
      if (key) {
        let arr = [];
        arr = columnOptions.filter(item => {
          return item.value == key;
        });
        return arr.length > 0 ? arr[0].text : '';
      }
    },

    /** 获取所有角色数据
     * @param {*}
     * @return {*}
     */
    async getRoleList() {
      let roleName = '';
      let res = await getRoleListData(roleName, 1000, 1);
      if (res.page && res.page.list && res.page.list.length > 0) {
        res.page.list.forEach(item => {
          this.rolesOptions.push({
            text: item.roleName,
            value: item.roleId,
          });
        });
      }
    },

    /** 获取所有用户数据
     * @param {*}
     * @return {*}
     */
    async getUserList() {
      if (this.tableLoading === true) {
        return;
      }
      this.tableLoading = true;
      let postData = { page: this.paginationTable.page, limit: this.paginationTable.limit.toString(), userCode: this.filterData.userCode };
      let res = await getUserListData(postData);
      this.userDataSource = res.code === 0 && res.page.list;
      this.paginationTable.total = res.code === 0 && res.page.totalCount;
      this.paginationTable.limit = res.code === 0 && res.page.pageSize;
      this.paginationTable.current = res.code === 0 && res.page.currPage;
      this.tableLoading = false;
    },

    /** 获取部门列表
     * @param {*}
     * @return {*}
     */
    getDepartment() {
      getDepartmentData().then(res => {
        if (res.code === 0) {
          this.departmentData = res.deptList;
        }
      });
    },

    /**查询用户事件
     * @param {*}
     * @return {*}
     */
    async selectUserClickBtn() {
      this.paginationTable.page = '1';
      this.getUserList();
    },

    /** 修改用户事件
     * @param {Object} record 用户的信息
     * @return {*}
     */
    updateUserClickBtn(record) {
      event.stopPropagation();
      if (record) {
        this.getDepartment();
        record.menuIdList = record.menuIdList ? record.menuIdList : [];
        this.editUserVisible = true;
        this.editUserModalType = '编辑用户';
        this.userModalData = {
          ...record,
        };
      }
    },
    /** 确认用户会话框事件
     * @param {*}
     * @return {*}
     */
    confirmUserModalClickBtn() {
      this.$refs.userModalForm.validate().then(() => {
        let postParams = {
          roleIdList: this.userModalData.roleIdList,
          userId: this.userModalData.userId,
        };
        updateUserData(postParams).then(res => {
          if (res.code === 0) {
            this.userModalData.menuIdList = [];
            this.$message.success('修改成功');
            this.cancelUserModalClickBtn();
            this.getUserList();
          }
        });
      });
    },

    /** 取消会话框事件
     * @param {*}
     * @return {*}
     */
    cancelUserModalClickBtn() {
      this.userModalData = {};
      this.editUserVisible = false;
      this.$refs.userModalForm.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
:deep(.filter_row) {
  .ant-input-affix-wrapper {
    line-height: 30px;
    padding: 0 10px;
    ant-input {
      height: 30px;
    }
  }
}
</style>
<style lang="less">
.letter-spac-2em {
  letter-spacing: 2em;
}
.user_system {
  .ant-table-scroll .ant-table-body {
    max-height: calc(100vh - 270px) !important;
  }
}
.user_role_modal {
  .ant-modal-body {
    overflow: auto;
    .ant-form {
      min-width: 680px;
      .ant-form-item-label {
        line-height: 40px;
      }
    }
  }
}
</style>